/* Lädt und startet stumme Hintergrund-Videos erst, wenn sie fast im Bild sind (spart beim
   Seitenaufruf mehrere MB). Falls der Browser
   Autoplay blockiert (Safari-Stromsparmodus), beim ersten Tippen, Klicken oder Tastendruck. */
(function () {
  if (window.__fcAutoplay) return;
  window.__fcAutoplay = true;

  function videos() {
    return Array.prototype.slice.call(document.querySelectorAll('video[data-fc-autoplay]'));
  }

  function prepare(v) {
    v.muted = true;
    v.defaultMuted = true;
    v.playsInline = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
  }

  /* Blockiert der Browser Autoplay, tauschen wir das Video gegen ein animiertes Bild.
     Das läuft auch im Stromsparmodus. Beim ersten Tippen kommt das echte Video zurück. */
  function swapToImage(v) {
    var src = v.getAttribute('data-fallback');
    if (!src || v.__fcSwapped) return;
    v.__fcSwapped = true;
    var img = document.createElement('img');
    img.src = src;
    img.alt = v.getAttribute('aria-label') || '';
    img.className = v.className;
    img.setAttribute('data-fc-fallback', '');
    img.decoding = 'async';
    img.onerror = function () { if (img.parentNode) img.parentNode.replaceChild(v, img); v.__fcSwapped = false; };
    v.parentNode.replaceChild(img, v);
    v.__fcImage = img;
  }

  function restoreVideo(v) {
    var img = v.__fcImage;
    if (!img || !img.parentNode) return;
    prepare(v);
    var p = v.play();
    if (p && typeof p.then === 'function') {
      p.then(function () {
        if (img.parentNode) img.parentNode.replaceChild(v, img);
        v.__fcImage = null; v.__fcSwapped = false;
      }).catch(function () {});
    }
  }

  function tryPlay(v) {
    if (!v.paused) return;
    if (v.preload === 'none') v.preload = 'auto';
    prepare(v);
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function () { swapToImage(v); armGesture(); });
  }

  var armed = false;
  function armGesture() {
    if (armed) return;
    armed = true;
    var events = ['touchstart', 'pointerdown', 'click', 'keydown'];
    function onGesture() {
      all.forEach(function (v) { if (v.__fcImage) restoreVideo(v); else tryPlay(v); });
      events.forEach(function (e) { document.removeEventListener(e, onGesture, true); });
      armed = false;
    }
    events.forEach(function (e) { document.addEventListener(e, onGesture, { capture: true, passive: true }); });
  }

  var all = [];
  function init() {
    var list = videos();
    all = list;
    list.forEach(prepare);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) tryPlay(en.target); });
      }, { rootMargin: '400px 0px', threshold: 0 });
      list.forEach(function (v) { io.observe(v); });
    } else {
      list.forEach(tryPlay);
    }
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) all.forEach(function (v) { if (!v.__fcImage) tryPlay(v); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
